import { getSafeRedirectTarget } from "./getSafeRedirectTarget";

// SSO hard-navigates away to the IdP and back, so a `redirect` query param
// can't survive the round trip — localStorage is the only thing that can.
export const SSO_LOGIN_REDIRECT_STORAGE_KEY = "@sidekick:sso-login-redirect";

export const storeSsoLoginRedirect = (redirect: string | null): void => {
  const safeRedirect = getSafeRedirectTarget(redirect);
  if (safeRedirect) {
    localStorage.setItem(SSO_LOGIN_REDIRECT_STORAGE_KEY, safeRedirect);
  } else {
    localStorage.removeItem(SSO_LOGIN_REDIRECT_STORAGE_KEY);
  }
};

export const consumeSsoLoginRedirect = (): string | null => {
  const stored = localStorage.getItem(SSO_LOGIN_REDIRECT_STORAGE_KEY);
  if (!stored) return null;
  localStorage.removeItem(SSO_LOGIN_REDIRECT_STORAGE_KEY);
  return getSafeRedirectTarget(stored);
};
